




























































































































































































import {Vue, Component} from 'vue-property-decorator';
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component
export default class Artikli extends mixins(ComponentBaseMixin) {
  artikal = {
    id: 0, publicID: '', ean: '', uoM: '', name: '', shortName: '',
    code: '', description: '', thumbnail: null, visible: false,
    sortOrder: 0, price: null, tax: null, productGroupID: null, migrationId: null
  };
  artikli = [];
  productGroupIDs = [];
  columns = [];
  tableOptions = {
    pagination: true,
    onClickRow: artikal => this.onArtikalClick(artikal),
  };
  isBusySave = false;

  img = require('@/assets/css/images/pattern.jpg');

  created() {
    this.columns = [
      {field: 'thumbnail', title: '', formatter: this.imageFormatter, width: 80},
      {field: 'name', title: this.$i18n.t('naziv'), sortable: true},
      {field: 'shortName', title: this.$i18n.t('kratkiNaziv'), sortable: true}
    ];
    this.ucitajGrupe();
  }

  mounted() {
    this.$nextTick(() => {
      (<any>this.$refs.observer).validate();
    });
    this.ucitajArtikle();
  }

  async ucitajArtikle() {
    this.artikli = [];
    let table = $('#articlesTable');
    try {
      table.bootstrapTable('showLoading');
      const {data} = await this.axios.get('api/GetAllProducts');
      this.artikli = data;
    } catch (err) {
      table.bootstrapTable('hideLoading');
      this.showError('greskaPrilikomUcitavanja');
    } finally {
      table.bootstrapTable('hideLoading');
    }
  }

  async ucitajGrupe() {
    try {
      await this.axios.get('api/GetProductGroups').then(result => {
        this.productGroupIDs = result.data;
      });
      this.productGroupIDs.unshift({id: '', name: '...'});
      this.productGroupIDs = this.productGroupIDs.map(x => ({id: x.id, text: x.name}));
    } catch (err) {
      this.showError('greskaPrilikomUcitavanjaGrupa');
    }
  }

  onArtikalClick(artikal) {
    this.artikal = artikal;
  }

  noviArtikal() {
    this.artikal = {
      id: 0, publicID: '', ean: '', uoM: '', name: '', shortName: '',
      code: '', description: '', thumbnail: '', visible: false,
      sortOrder: 0, price: '', tax: '', productGroupID: '', migrationId: null
    };
  }

  async sacuvajArtikal() {
    const valid = await (<any>this.$refs.observer).validate();
    if (valid) {
      try {
        this.isBusySave = true;
        await this.axios.post('api/SaveProduct', this.artikal);
        await this.ucitajArtikle();
        this.showInfo('podaciUspesnoSacuvani');
      } catch (e) {
        this.showError('neuspesnoCuvanjePodataka');
        this.isBusySave = false;
      } finally {
        this.isBusySave = false;
      }
    } else {
      this.showInfo('nisu sva obavezna polja popunjena');
    }
  }

  imageFormatter(value, row) {
    return value ? '<img src="' + value + '" height="32">' : ''
  }

}
